export default {
    name: 'newsletter',
    component() {
        return {
            isNewsletterOpen: false,
            isSuccess: false,
            serverMessage: false,
            isSubmitting: false,

            toggleNewsletter() {
                this.isNewsletterOpen = !this.isNewsletterOpen;
            },

            async subscribe(email) {
                const valid = true;

                if (valid) {
                    const myForm = document.querySelector('#at-newsletter-subscribe-form');
                    window.Shopify.captcha.protect(myForm, () => {
                        myForm.elements["contact[email]"].value = email;
                        myForm.elements["contact[tags]"].value = 'newsletter';
                        myForm.elements["utf8"].value = '✓';
                        myForm.elements["form_type"].value = 'customer';
                        myForm.submit();
                    });

                    this.isSubmitting = true;

                } else {
                    console.log('Form is invalid');
                }
            }
        }
    }
}
